import { translate } from '@comparacar/lib/src/translations'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import React from 'react'
const AlertComparaCarSecurity: React.FC = () => {
  return (
    <Alert severity="success">
      <AlertTitle>{translate('AlertComparaCarSecurity.title')}</AlertTitle>
      {translate('AlertComparaCarSecurity.message')}
    </Alert>
  )
}
export default AlertComparaCarSecurity
